export enum PlanPurchaseDataEventObjectsEnum {
  PLAN_PURCHASE_POPUP = 'plan_purchase_popup',
  SELECT_PLAN = 'select_plan',
  DOWNGRADE_EXCEEDING_LIMITS = 'downgrade_exceeding_limits',
}
